export default "__VITE_ASSET__0k98jAOU__"